import { Component } from "@angular/core";
import { Routes, Router } from "@angular/router";

import { BaMenuService } from "../theme";
import { PAGES_MENU } from "./pages.menu";

@Component({
  selector: "pages",
  template: `
    <ba-sidebar></ba-sidebar>
    <ba-page-top></ba-page-top>
    <div class="al-main" [ngStyle]="style">
      <div class="al-content">
        <ba-content-top [hidden]="!showTitleSec"></ba-content-top>
        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- <footer class="al-footer clearfix">
      <div class="al-footer-main clearfix">
        <div class="al-copy">&copy; <a href="http://www.emser.net" translate>Emser</a> 2019-2020</div>
      </div>
    </footer> -->
    <ba-back-top position="200"></ba-back-top>
  `
})
export class Pages {
  private subscribedNav;
  public showTitleSec = true;
  public style: any = {};

  constructor(private _menuService: BaMenuService, private _router: Router) {
    this.subscribedNav = _router.events.subscribe(event => this.setNav(event));
  }

  ngOnInit() {
    this._menuService.updateMenuByRoutes(<Routes>PAGES_MENU);
  }

  private setNav(event) {
    if (event.url == "/pages/adminauditorspoints/surveypointsmap") {
      this.showTitleSec = false;
      this.style = { padding: "31px 0 0px 0" };
    } else {
      this.showTitleSec = true;
      this.style = {};
    }
  }

  ngOnDestroy() {
    this.subscribedNav.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/pages.component.ts